let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8cG9a")).then(() => parcelRequire('1zDn7'));